import styled from "styled-components";

export const PageIcon = styled.img`
  width: ${props => props.width};
  margin: 0 auto;
  display: block;
`;
